import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import * as i2 from 'angular-auth-oidc-client';
import { AuthModule } from 'angular-auth-oidc-client';
import { tap, BehaviorSubject, of, switchMap, filter } from 'rxjs';
import { map, filter as filter$1 } from 'rxjs/operators';
import * as i1$1 from '@angular/router';
import * as i1 from '@angular/common/http';
import { HttpParams, HttpHeaders } from '@angular/common/http';

class AuthConfiguration {
}
class IframeIntegrationConfig {
    constructor() {
        this.origins = [];
        this.destinations = [];
    }
}

class LoggerService {
    constructor() { }
    loggerEnabled() {
        return !!localStorage.getItem('_logger');
    }
    log(message, ...optionalParams) {
        if (!this.loggerEnabled())
            return;
        if (!optionalParams || optionalParams.length === 0) {
            console.log(message);
            return;
        }
        console.log(message, optionalParams);
    }
    warn(message, ...optionalParams) {
        if (!this.loggerEnabled())
            return;
        if (!optionalParams || optionalParams.length === 0) {
            console.warn(message);
            return;
        }
        console.warn(message, optionalParams);
    }
    error(message, ...optionalParams) {
        if (!this.loggerEnabled())
            return;
        if (!optionalParams || optionalParams.length === 0) {
            console.error(message);
            return;
        }
        console.error(message, optionalParams);
    }
}
LoggerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.6", ngImport: i0, type: LoggerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
LoggerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.6", ngImport: i0, type: LoggerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.6", ngImport: i0, type: LoggerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

class IamService {
    constructor(httpClient, oidcSecurityService, logger) {
        this.httpClient = httpClient;
        this.oidcSecurityService = oidcSecurityService;
        this.logger = logger;
        this._currentUser = null;
    }
    get currentUser() {
        return this._currentUser;
    }
    set currentUser(value) {
        this._currentUser = value;
    }
    exchangeSessionIdForAppSession(sessionId, externalUserRef, externalOrganizationRef) {
        const config = this.oidcSecurityService.getConfiguration();
        let params = new HttpParams();
        if (sessionId)
            params = params.set('id', sessionId);
        if (externalUserRef)
            params = params.set('externalUserRef', externalUserRef);
        if (externalOrganizationRef)
            params = params.set('externalOrganizationRef', externalOrganizationRef);
        params = params.set('scope', config.scope);
        return this.httpClient
            .get(config.authority + `/session`, { params: params })
            .pipe(tap((d) => {
            this.currentUser = this.getCurrentUser(d.access_token, externalOrganizationRef, externalUserRef);
        }));
    }
    refreshToken(refreshToken, organizationId) {
        this.logger.log('performing manual token refresh');
        const config = this.oidcSecurityService.getConfiguration();
        const body = new URLSearchParams();
        body.set('grant_type', 'refresh_token');
        body.set('refresh_token', refreshToken);
        body.set('client_id', config.clientId ?? 'NA');
        body.set('scope', config.scope);
        body.set('organization_id', organizationId);
        const options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
        };
        return this.httpClient.post(String(config.authWellknownEndpoints?.tokenEndpoint), body, options);
    }
    exchangeToken(actAsSub, organizationId) {
        this.logger.log('performing token exchange');
        const config = this.oidcSecurityService.getConfiguration();
        const body = new URLSearchParams();
        body.set('grant_type', 'urn:ietf:params:oauth:grant-type:token-exchange');
        body.set('subject_token', this.oidcSecurityService.getAccessToken());
        body.set('subject_token_type', 'urn:ietf:params:oauth:token-type:access_token');
        body.set('act_as', actAsSub);
        body.set('client_id', config.clientId ?? 'NA');
        body.set('scope', config.scope);
        body.set('organization_id', organizationId);
        const options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
        };
        return this.httpClient.post(String(config.authWellknownEndpoints?.tokenEndpoint), body, options);
    }
    isSubjectHasChanged(token, externalCompanyId) {
        if (!token)
            return false;
        const newCurrentUser = this.getCurrentUser(token, externalCompanyId);
        // console.log(newCurrentUser);
        this.logger.log(this.currentUser);
        return (newCurrentUser.id !== this.currentUser?.id ||
            newCurrentUser.externalCompanyId !== this.currentUser?.externalCompanyId);
    }
    getCurrentUser(token, externalCompanyId, externalUserRef = null) {
        if (!token || token.split('.').length != 3)
            return null;
        const { sub, organization_id } = JSON.parse(atob(token.split('.')[1]));
        return {
            id: externalUserRef || String(sub),
            organizationId: String(organization_id),
            externalCompanyId,
        };
    }
    getSubject(token) {
        if (!token || token.split('.').length != 3)
            return null;
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload?.sub;
    }
}
IamService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.6", ngImport: i0, type: IamService, deps: [{ token: i1.HttpClient }, { token: i2.OidcSecurityService }, { token: LoggerService }], target: i0.ɵɵFactoryTarget.Injectable });
IamService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.6", ngImport: i0, type: IamService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.6", ngImport: i0, type: IamService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.OidcSecurityService }, { type: LoggerService }]; } });

const AUTH_PARAMS = Object.freeze({
    SESSION_ID: 'sessionId',
    SUB_EXTERNAL_REF_LEGACY: 'externalRef',
    SUB_EXTERNAL_ORG_REF_LEGACY: 'organizationId',
    ACT_AS: 'act-as',
    ORGANIZATION_EXTERNAL_REF: 'org-external-ref',
    ORGANIZATION_ID: 'organization-id',
    ACR: 'acr',
});
const DEFAULT_AUTHRESULT = { isAuthenticated: false };
class IntegrationAuthService {
    constructor(logger, activatedRoute, iamService, oidcSecurityService, oidcConfigService, iframeCommService) {
        this.logger = logger;
        this.activatedRoute = activatedRoute;
        this.iamService = iamService;
        this.oidcSecurityService = oidcSecurityService;
        this.oidcConfigService = oidcConfigService;
        this.iframeCommService = iframeCommService;
        this.authenticatedInternal$ = new BehaviorSubject(DEFAULT_AUTHRESULT);
        this.tokenRefreshing = false;
        this.authenticating = false;
        this.tokenExchanging = false;
        this.impersonatedUser = '';
        this.iframeIntegration = false;
        this.authMessage = '';
        this._isIntegration = false;
    }
    get isImpersonation() {
        return !!sessionStorage.getItem(AUTH_PARAMS.ACT_AS);
    }
    get isAuthenticated$() {
        return this.authenticatedInternal$.asObservable();
    }
    reigsterAuthHandlers() {
        this.rememberCustomAuthParams();
        this.restoreCustomAuthParams();
        if (this.accessTokenIsExpired()) {
            this.logger.log('Access token is expired. Logging off local user session..');
            this.oidcSecurityService.logoffLocal();
        }
        this.oidcSecurityService.checkAuth().subscribe();
        this.restoreSession().subscribe();
        this.checkForIntegration();
        this.authenticationUsingSessionIdHandler();
        this.legacyAuthenticationUsingQueryParamsHandler();
        this.legacyAuthenticationUsingIframeMessageHandler();
        this.listenAndNotifyAuthenticationChanges();
    }
    listenAndNotifyAuthenticationChanges() {
        this.oidcSecurityService.isAuthenticated$.subscribe((result) => {
            if (this.isImpersonation)
                return;
            this.authenticatedInternal$.next({
                isAuthenticated: result.isAuthenticated,
            });
        });
    }
    registerImpersonationHandlers() {
        this.impersonateWhenSessionIsReady();
    }
    authenticationUsingSessionIdHandler() {
        this.activatedRoute.queryParams.subscribe((params) => {
            if (!params[AUTH_PARAMS.SESSION_ID])
                return;
            this.initCustomAuthentication(params[AUTH_PARAMS.SESSION_ID], null, null);
        });
    }
    legacyAuthenticationUsingQueryParamsHandler() {
        this.activatedRoute.queryParams.subscribe((params) => {
            if (!(params[AUTH_PARAMS.SUB_EXTERNAL_REF_LEGACY] &&
                params[AUTH_PARAMS.SUB_EXTERNAL_ORG_REF_LEGACY]))
                return;
            this.initCustomAuthentication(null, params[AUTH_PARAMS.SUB_EXTERNAL_REF_LEGACY], params[AUTH_PARAMS.SUB_EXTERNAL_ORG_REF_LEGACY]);
        });
    }
    legacyAuthenticationUsingIframeMessageHandler() {
        this.iframeCommService
            .listen(['context'])
            .subscribe((message) => {
            this.iframeIntegration = true;
            if (!message.session?.company?.external_company_id)
                return;
            if (this.oidcSecurityService.isAuthenticated() &&
                !this.iamService.isSubjectHasChanged(message?.access_token, message.session?.company?.external_company_id))
                return;
            const subject = this.iamService.getSubject(message?.access_token);
            this.initCustomAuthentication(null, subject, message.session?.company?.external_company_id);
        });
    }
    initCustomAuthentication(sessionId, externalUserRef, externalOrganizationRef) {
        this.iframeIntegration = true;
        this.authenticating = true;
        this.iamService
            .exchangeSessionIdForAppSession(sessionId, externalUserRef, externalOrganizationRef)
            .subscribe({
            next: (session) => {
                this.authenticating = false;
                if (!session) {
                    this.logger.error('Failing iframe integration: No valid session found.');
                    return;
                }
                this.setupClientConfig(session.client_id, this.iamService.currentUser.organizationId).then((_) => this.refreshTokenManuallyInternal(session.refresh_token));
            },
            error: () => (this.authenticating = false),
        });
    }
    async setupClientConfig(client_id, organizationId) {
        const _ = await this.rememberClient(client_id);
        return this.restoreSession(organizationId);
    }
    fulfillAuthLibPrerequisites(response) {
        const existingIdToken = this.oidcSecurityService.getIdToken();
        response.id_token = response.id_token ?? existingIdToken;
        const { configId } = this.oidcSecurityService.getConfiguration();
        var storage = JSON.parse(window.sessionStorage.getItem(configId) ?? '{}');
        storage['authzData'] = response.access_token;
        storage['authnResult'] = response;
        storage['userData'] = {};
        const accessTokenExpiryTime = new Date(new Date().toUTCString()).valueOf() + response.expires_in * 1000;
        storage['access_token_expires_at'] = accessTokenExpiryTime;
        // move to latest configuration
        window.sessionStorage.setItem(configId, JSON.stringify(storage));
    }
    checkForIntegration() {
        this.activatedRoute.queryParams.subscribe((_) => {
            const urlSearchParams = new URLSearchParams(window.location.search);
            if (!urlSearchParams.has('integration'))
                return;
            this.iframeIntegration = urlSearchParams.has('integration');
        });
    }
    get userHasSignedOut() {
        const result = !this.oidcSecurityService.isAuthenticated() &&
            !this.tokenRefreshing &&
            !this.authenticating;
        return result;
    }
    rememberClient(clientId) {
        return new Promise((resolve) => {
            sessionStorage.setItem('integration', clientId);
            const config = this.oidcSecurityService.getConfiguration();
            config.customParamsRefreshTokenRequest = {
                organization_id: this.iamService.currentUser.organizationId,
            };
            this.oidcConfigService
                .withConfigs([config])
                .subscribe((_) => resolve(true));
        });
    }
    restoreSession(organizationId = null) {
        const clientId = sessionStorage.getItem('integration');
        if (!clientId)
            return of(false);
        const config = this.oidcSecurityService.getConfiguration();
        // update app configs with new client id
        config.clientId = clientId;
        // important to avoid Id token validaty check when using ROPC based iframe integration with silent token renewal
        config.enableIdTokenExpiredValidationInRenew = false;
        if (organizationId)
            config.customParamsRefreshTokenRequest['organization_id'] =
                organizationId;
        return this.oidcConfigService.withConfigs([config]).pipe(switchMap((_) => {
            if (this.accessTokenIsExpired() &&
                !this.lastSilentRenewalWasInterrupted())
                this.refreshTokenManuallyInternal();
            return of(false);
        }));
    }
    refreshTokenManually(refreshToken = null) {
        refreshToken = refreshToken || this.oidcSecurityService.getRefreshToken();
        if (!refreshToken)
            return of(null);
        this.tokenRefreshing = true;
        const config = this.oidcSecurityService.getConfiguration();
        const organizationId = config.customParamsRefreshTokenRequest['organization_id']?.toString();
        return this.iamService.refreshToken(refreshToken, organizationId).pipe(tap((response) => {
            this.tokenRefreshing = false;
            this.kickInAuthLibraryFlow(response);
        }));
    }
    refreshTokenManuallyInternal(refreshToken = null) {
        return this.refreshTokenManually(refreshToken).subscribe((response) => {
            this.tokenRefreshing = false;
            this.kickInAuthLibraryFlow(response);
        });
    }
    accessTokenIsExpired() {
        const { configId, renewTimeBeforeTokenExpiresInSeconds } = this.oidcSecurityService.getConfiguration();
        const session = JSON.parse(sessionStorage.getItem(configId));
        const hasAccessTokenExpiry = !(session.access_token_expires_at == null || session.access_token_expires_at == undefined);
        // value is optional, so if it does not exist, then it has not expired
        if (!hasAccessTokenExpiry)
            return false;
        const accessTokenExpiresAt = new Date(session.access_token_expires_at);
        sessionStorage.setItem(configId, JSON.stringify(session));
        var offsetSeconds = renewTimeBeforeTokenExpiresInSeconds || 0;
        // offsetSeconds = offsetSeconds || 0;
        const accessTokenExpirationValue = accessTokenExpiresAt.valueOf();
        const nowWithOffset = new Date(new Date().toUTCString()).valueOf() + offsetSeconds * 1000;
        const tokenNotExpired = accessTokenExpirationValue > nowWithOffset;
        return !tokenNotExpired;
    }
    lastSilentRenewalWasInterrupted() {
        // use when the browser tab is refreshed, in the middle of silent renewal
        const { configId } = this.oidcSecurityService.getConfiguration();
        const session = JSON.parse(sessionStorage.getItem(configId));
        if (!session.storageSilentRenewRunning)
            return false;
        const silentRenewal = JSON.parse(session.storageSilentRenewRunning);
        const interrupted = silentRenewal?.state === 'running';
        if (!interrupted)
            return false;
        delete session.authnResult;
        delete session.authzData;
        this.logger.log('previous renewal was interrupted. clearing past session...');
        sessionStorage.setItem(configId, JSON.stringify(session));
        return true;
    }
    get email() {
        if (this.oidcSecurityService.isAuthenticated())
            return;
        return this.oidcSecurityService.getPayloadFromIdToken(false)['email'];
    }
    impersonateWhenSessionIsReady() {
        this.whenSignedInCompletedInternal().then(() => {
            if (!this.isImpersonation || this.tokenExchanging)
                return;
            const currentSubject = this.oidcSecurityService.getPayloadFromIdToken(false)['sub'];
            const actAsSubject = sessionStorage.getItem(AUTH_PARAMS.ACT_AS);
            if (currentSubject === actAsSubject) {
                this.clearImpersonatedUser();
                return;
            }
            this.logger.log(this.email + ' -> performing impersonation...');
            this.authMessage = 'Performing impersonation...';
            this.tokenExchanging = true;
            this.iamService
                .exchangeToken(sessionStorage.getItem(AUTH_PARAMS.ACT_AS), sessionStorage.getItem(AUTH_PARAMS.ORGANIZATION_ID))
                .subscribe({
                next: (response) => {
                    this.authMessage = '';
                    this.clearImpersonatedUser();
                    this.changeExistingIdTokenSubToBypassLibrarySubCheck();
                    this.tokenExchanging = false;
                    this.kickInAuthLibraryFlow(response);
                    this.oidcSecurityService.forceRefreshSession().subscribe(() => {
                        this.logger.log('refreshing session');
                        window.location.reload();
                    });
                },
                error: () => (this.tokenExchanging = false),
            });
        });
    }
    clearImpersonatedUser() {
        this.impersonatedUser = sessionStorage.getItem(AUTH_PARAMS.ACT_AS);
        sessionStorage.setItem('impersonated-session', this.impersonatedUser);
        sessionStorage.removeItem(AUTH_PARAMS.ACT_AS);
    }
    kickInAuthLibraryFlow(response) {
        this.fulfillAuthLibPrerequisites(response);
        this.oidcSecurityService.checkAuth().subscribe();
    }
    whenSignedInCompletedInternal() {
        return new Promise((resolve) => {
            this.oidcSecurityService.isAuthenticated$
                .pipe(filter((d) => d.isAuthenticated))
                .subscribe((_) => resolve(true));
        });
    }
    whenSignedInCompleted() {
        return new Promise((resolve) => {
            this.isAuthenticated$
                .pipe(filter((d) => d.isAuthenticated), switchMap((d) => of(d)))
                .subscribe((result) => {
                this.logger.log('New signed in: ' + this.email);
                resolve(result.isAuthenticated);
            });
        });
    }
    signing() {
        return !!this.oidcSecurityService.getState();
    }
    rememberCustomAuthParams() {
        return new Promise((resolve) => {
            this.activatedRoute.queryParams
                .pipe(filter((params) => !!params[AUTH_PARAMS.ACT_AS]), switchMap((params) => of(params)))
                .subscribe((params) => {
                sessionStorage.setItem(AUTH_PARAMS.ACT_AS, params[AUTH_PARAMS.ACT_AS]);
                sessionStorage.setItem(AUTH_PARAMS.ORGANIZATION_ID, params[AUTH_PARAMS.ORGANIZATION_ID]);
                resolve(true);
            });
        });
    }
    restoreCustomAuthParams() {
        const config = this.oidcSecurityService.getConfiguration();
        this.addCustomParamsForTokenRefreshRequest(config);
        this.addCustomParamsForCodeExchageRequest(config);
        config.disableRefreshIdTokenAuthTimeValidation = !!sessionStorage.getItem(AUTH_PARAMS.ACT_AS);
        this.oidcConfigService.withConfigs([config]).subscribe((_) => { });
    }
    addCustomParamsForTokenRefreshRequest(config) {
        if (!sessionStorage.getItem(AUTH_PARAMS.ACT_AS) &&
            !sessionStorage.getItem(AUTH_PARAMS.ORGANIZATION_ID))
            return;
        const customRefreshTokenParams = {
            act_as: String(sessionStorage.getItem(AUTH_PARAMS.ACT_AS)),
            organization_id: String(sessionStorage.getItem(AUTH_PARAMS.ORGANIZATION_ID)),
        };
        config.customParamsRefreshTokenRequest = customRefreshTokenParams;
    }
    addCustomParamsForCodeExchageRequest(config) {
        const state = this.oidcSecurityService.getState()
            ? JSON.parse(this.oidcSecurityService.getState())
            : {};
        if (!state[AUTH_PARAMS.ORGANIZATION_EXTERNAL_REF])
            return;
        const organizationExternalRef = state[AUTH_PARAMS.ORGANIZATION_EXTERNAL_REF];
        if (organizationExternalRef) {
            const customCodeParams = {
                external_organization_ref: organizationExternalRef,
            };
            config.customParamsCodeRequest = customCodeParams;
        }
    }
    changeExistingIdTokenSubToBypassLibrarySubCheck() {
        // this step is mandatory during token-exchange.
        // the initial issued id token is belongs to superadmin. After token exchange, the initial refresh token request will loads a new Id Token to the library
        // Which belongs to the impersonated user. After that the library will perform id token validation using existingIdToken and the newIdToken before save.
        // If does not match, it will throw 'sub do not match:' error and session will be cleared!!! This step is to override that validation check
        const { configId } = this.oidcSecurityService.getConfiguration();
        const session = JSON.parse(sessionStorage.getItem(configId));
        session.authnResult.id_token = alterIdTokenSubject(session.authnResult.id_token, this.impersonatedUser);
        sessionStorage.setItem(configId, JSON.stringify(session));
        function alterIdTokenSubject(token, actAs) {
            if (!token || token.split('.').length != 3)
                return null;
            const payload = token.split('.')[1];
            const header = token.split('.')[0];
            const signature = token.split('.')[2];
            const payloadDecoded = JSON.parse(atob(payload));
            payloadDecoded.sub = actAs;
            const alteredPayload = btoa(JSON.stringify(payloadDecoded));
            return `${header}.${alteredPayload}.${signature}`;
        }
    }
    checkIntegration() {
        const urlSearchParams = new URLSearchParams(window.location.search);
        this.logger.log('integration check URL: ' + window.location.search);
        this._isIntegration = Boolean(urlSearchParams.get('integration'));
    }
    get isIntegration() {
        return this._isIntegration;
    }
    get hasSelectedOrganization() {
        return Boolean(sessionStorage.getItem('organization-selected'));
    }
}
IntegrationAuthService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.6", ngImport: i0, type: IntegrationAuthService, deps: [{ token: LoggerService }, { token: i1$1.ActivatedRoute }, { token: IamService }, { token: i2.OidcSecurityService }, { token: i2.OidcConfigService }, { token: IframeCommService }], target: i0.ɵɵFactoryTarget.Injectable });
IntegrationAuthService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.6", ngImport: i0, type: IntegrationAuthService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.6", ngImport: i0, type: IntegrationAuthService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: LoggerService }, { type: i1$1.ActivatedRoute }, { type: IamService }, { type: i2.OidcSecurityService }, { type: i2.OidcConfigService }, { type: IframeCommService }]; } });

class InternalSessionService {
    constructor(router, oidcSecurityService, oidcConfigService, logger) {
        this.router = router;
        this.oidcSecurityService = oidcSecurityService;
        this.oidcConfigService = oidcConfigService;
        this.logger = logger;
        this.userHasChangedInternal$ = new BehaviorSubject(false);
        this.hashCode = function (value) {
            return Math.abs(Number(value.split('').reduce(function (a, b) {
                a = (a << 5) - a + b.charCodeAt(0);
                return a & a;
            }, 0)));
        };
        this._sessionId = '';
        this.state = new Object();
    }
    async clearSession() {
        this.logger.log('Clearing previous logging session...');
        this.userHasChangedInternal$.next(true);
        this.oidcSecurityService.logoffLocal();
        await this.router.navigate(['sign-in']);
    }
    async clearSessionIfSessionChanged() {
        if (this.previousSessionHasChanged()) {
            await this.clearSession();
        }
    }
    previousSessionHasChanged() {
        const previousSessionHash = Number(sessionStorage.getItem('_session'));
        const currentSessionHash = this.hashCode(this.sessionId);
        return (previousSessionHash !== 0 &&
            currentSessionHash !== 0 &&
            previousSessionHash !== currentSessionHash);
    }
    signOut(local = false) {
        if (local) {
            this.clearSigningStateExceptIdToken();
            return;
        }
        this.oidcSecurityService.logoff();
    }
    signIn() {
        const { configId } = this.oidcSecurityService.getConfiguration();
        this.oidcSecurityService.setState(JSON.stringify(this.state));
        if (!this.isNull(this.state[AUTH_PARAMS.ACR])) {
            this.oidcSecurityService.authorize(configId, {
                customParams: {
                    acr_values: `idp:${this.state[AUTH_PARAMS.ACR]}`,
                },
            });
            return;
        }
        this.oidcSecurityService.authorize();
    }
    get sessionId() {
        let urlString = window.location.href;
        urlString = urlString.replace(/&amp;/g, '&');
        const url = new URL(urlString);
        const urlSearchParams = new URLSearchParams(url.search);
        const acr = String(urlSearchParams.get(AUTH_PARAMS.ACR));
        const orgExternalRef = String(urlSearchParams.get(AUTH_PARAMS.ORGANIZATION_EXTERNAL_REF));
        if (!this.isNull(orgExternalRef)) {
            sessionStorage.setItem('organization-selected', 'true');
            this.state[AUTH_PARAMS.ORGANIZATION_EXTERNAL_REF] = orgExternalRef;
            this.addAttributeToSignInSession(orgExternalRef);
        }
        if (!this.isNull(acr)) {
            this.state[AUTH_PARAMS.ACR] = acr;
            this.addAttributeToSignInSession(acr);
        }
        return this._sessionId;
    }
    addAttributeToSignInSession(val) {
        this._sessionId = this._sessionId + val;
        this.rememberSession();
    }
    rememberSession() {
        sessionStorage.setItem('_session', this.hashCode(this._sessionId).toString());
    }
    isNull(val) {
        return !val || val == 'null';
    }
    isAuthenticated() {
        return this.oidcSecurityService.isAuthenticated();
    }
    clearSigningStateExceptIdToken() {
        const { configId } = this.oidcSecurityService.getConfiguration();
        const clientSession = JSON.parse(sessionStorage.getItem(configId));
        clientSession['authStateControl'] = '';
        clientSession['authNonce'] = '';
        clientSession['authzData'] = '';
        if (clientSession['authnResult']) {
            clientSession['authnResult']['access_token'] = '';
            clientSession['authnResult']['refresh_token'] = '';
        }
        sessionStorage.setItem(configId, JSON.stringify(clientSession));
    }
    getIdTokenPayload() {
        if (!this.oidcSecurityService.isAuthenticated())
            return {};
        return this.oidcSecurityService.getPayloadFromIdToken(false);
    }
    saveCustomAuthParams(customParams) {
        const config = this.oidcSecurityService.getConfiguration();
        config.customParamsCodeRequest = customParams;
        config.customParamsRefreshTokenRequest = customParams;
        return this.oidcConfigService.withConfigs([config]);
    }
    silentRenewRunning() {
        const { configId } = this.oidcSecurityService.getConfiguration();
        const session = JSON.parse(sessionStorage.getItem(configId));
        if (!session.storageSilentRenewRunning)
            return false;
        const silentRenewal = JSON.parse(session.storageSilentRenewRunning);
        const running = silentRenewal?.state === 'running';
        return running;
    }
}
InternalSessionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.6", ngImport: i0, type: InternalSessionService, deps: [{ token: i1$1.Router }, { token: i2.OidcSecurityService }, { token: i2.OidcConfigService }, { token: LoggerService }], target: i0.ɵɵFactoryTarget.Injectable });
InternalSessionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.6", ngImport: i0, type: InternalSessionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.6", ngImport: i0, type: InternalSessionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.Router }, { type: i2.OidcSecurityService }, { type: i2.OidcConfigService }, { type: LoggerService }]; } });

class IframeCommService {
    constructor(config, internalSession, iamService) {
        this.config = config;
        this.internalSession = internalSession;
        this.iamService = iamService;
        this.messages = new BehaviorSubject(null);
        this.initiateListner(this.config.iframe_integration.origins);
    }
    initiateListner(whiteListedOrigins) {
        window.addEventListener('message', async (event) => {
            if (!this.isFromTrustedOrigin(whiteListedOrigins, event))
                return;
            let message = JSON.parse(event.data);
            if (!message?.pakage?.startApp)
                this.republish(event);
            if (this.iamService.isSubjectHasChanged(message.pakage?.context?.access_token, message.pakage?.context?.session?.company?.external_company_id))
                await this.internalSession.clearSession();
            this.acknowledge(message, event);
        }, false);
    }
    isFromTrustedOrigin(whiteListedOrigins, event) {
        return whiteListedOrigins.some((domain) => domain === event.origin);
    }
    republish(event) {
        this.messages.next(event.data);
    }
    acknowledge(dataPackage, event) {
        dataPackage.meta.delivered = true;
        event.source.postMessage(JSON.stringify(dataPackage), event.origin);
    }
    listen(properties) {
        if (properties === null || properties.length === 0)
            return null;
        return this.messages.pipe(map((message) => this.filterNestedObject(properties, message)), filter$1((data) => !!data));
    }
    filterNestedObject(properties, message) {
        if (!message)
            return null;
        let filteredObject = JSON.parse(message).pakage;
        if (!filteredObject)
            return null;
        properties.forEach((property) => {
            if (!filteredObject)
                return;
            filteredObject = filteredObject[property];
        });
        return filteredObject;
    }
    dispatch(message) {
        this.config.iframe_integration.destinations.forEach((destination) => {
            window.parent.postMessage(JSON.stringify(message), destination);
        });
    }
}
IframeCommService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.6", ngImport: i0, type: IframeCommService, deps: [{ token: AuthConfiguration }, { token: InternalSessionService }, { token: IamService }], target: i0.ɵɵFactoryTarget.Injectable });
IframeCommService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.6", ngImport: i0, type: IframeCommService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.6", ngImport: i0, type: IframeCommService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: AuthConfiguration }, { type: InternalSessionService }, { type: IamService }]; } });

class BnaServicesAuthClientModule {
    constructor(iframeComm, integrationAuth) {
        this.iframeComm = iframeComm;
        this.integrationAuth = integrationAuth;
        this.iframeComm.listen([]);
        this.integrationAuth.checkIntegration();
    }
    static forRoot(libConfiguration) {
        return {
            ngModule: BnaServicesAuthClientModule,
            providers: [
                {
                    provide: AuthConfiguration,
                    useValue: libConfiguration,
                },
                ...AuthModule.forRoot(libConfiguration.authConfig).providers,
            ],
        };
    }
    init() {
        this.integrationAuth.reigsterAuthHandlers();
        this.integrationAuth.registerImpersonationHandlers();
    }
}
BnaServicesAuthClientModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.6", ngImport: i0, type: BnaServicesAuthClientModule, deps: [{ token: IframeCommService }, { token: IntegrationAuthService }], target: i0.ɵɵFactoryTarget.NgModule });
BnaServicesAuthClientModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.6", ngImport: i0, type: BnaServicesAuthClientModule });
BnaServicesAuthClientModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.6", ngImport: i0, type: BnaServicesAuthClientModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.6", ngImport: i0, type: BnaServicesAuthClientModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                }]
        }], ctorParameters: function () { return [{ type: IframeCommService }, { type: IntegrationAuthService }]; } });

class UserSessionService {
    constructor(router, integrationAuthService, internalSession) {
        this.router = router;
        this.integrationAuthService = integrationAuthService;
        this.internalSession = internalSession;
    }
    switchOrganization(organizationId) {
        return this.internalSession
            .saveCustomAuthParams({
            organization_id: organizationId,
        })
            .pipe(switchMap(() => this.changeSessionAndRefresh()));
    }
    changeSessionAndRefresh() {
        return this.integrationAuthService.refreshTokenManually().pipe(tap(() => {
            this.internalSession.userHasChangedInternal$.next(true);
            this.router.navigate(['sign-in']);
        }), switchMap(() => of(true)));
    }
    // public silentRenewRunning() {
    //   return this.internalSession.silentRenewRunning();
    // }
    get isAuthenticated$() {
        return this.integrationAuthService.isAuthenticated$;
    }
    get userHasChanged$() {
        return this.internalSession.userHasChangedInternal$.asObservable();
    }
    isAuthenticated() {
        return this.internalSession.isAuthenticated();
    }
    getProfile() {
        const idTokenPayload = this.internalSession.getIdTokenPayload();
        const country = idTokenPayload['country']
            ? JSON.parse(idTokenPayload['country'])
            : null;
        return {
            id: idTokenPayload['sub'],
            email: idTokenPayload['email'],
            name: idTokenPayload['name'],
            familyName: idTokenPayload['family_name'],
            userGroup: idTokenPayload['user_group'],
            phoneNumber: idTokenPayload['phone_number'],
            organizationId: idTokenPayload['organization_id'],
            userReferenceId: idTokenPayload['sub_ref'],
            picture: idTokenPayload['picture'],
            country: country
                ? {
                    id: country['Id'],
                    code: country['Code'],
                }
                : null,
        };
    }
    signOut(local = false) {
        this.internalSession.signOut(local);
    }
    signIn() {
        this.internalSession.signIn();
    }
    async signing() {
        await this.internalSession.clearSessionIfSessionChanged();
        return this.integrationAuthService.signing();
    }
    whenSignedInCompleted() {
        return this.integrationAuthService.whenSignedInCompleted();
    }
    addSessionQueryParams(redirectUrl) {
        const actor = sessionStorage.getItem('impersonated-session');
        var url = new URL(redirectUrl);
        var search_params = url.searchParams;
        if (actor) {
            url.pathname =
                (url.pathname === '/' ? '' : `${url.pathname}/`) + 'sign-in';
            const idTokenPayload = this.internalSession.getIdTokenPayload();
            const organizationId = idTokenPayload['organization_id'];
            search_params.set('act-as', String(actor));
            search_params.set('organization-id', String(organizationId));
        }
        if (this.isIntegration) {
            search_params.set('integration', 'true');
        }
        url.search = search_params.toString();
        return url.toString();
    }
    get isIntegration() {
        return this.integrationAuthService.isIntegration;
    }
    get hasSelectedOrganization() {
        return this.integrationAuthService.hasSelectedOrganization;
    }
    get isSignedOut() {
        return this.integrationAuthService.userHasSignedOut;
    }
    get authMessage() {
        return this.integrationAuthService.authMessage;
    }
}
UserSessionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.6", ngImport: i0, type: UserSessionService, deps: [{ token: i1$1.Router }, { token: IntegrationAuthService }, { token: InternalSessionService }], target: i0.ɵɵFactoryTarget.Injectable });
UserSessionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.6", ngImport: i0, type: UserSessionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.6", ngImport: i0, type: UserSessionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.Router }, { type: IntegrationAuthService }, { type: InternalSessionService }]; } });

/*
 * Public API Surface of bna-services-auth-client
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AuthConfiguration, BnaServicesAuthClientModule, IframeCommService, IframeIntegrationConfig, LoggerService, UserSessionService };
